import React from "react";
import { UserCircle2 } from "lucide-react";
import TableActionButtons from '../../CommonComponents/TableActionButtons';
import EmptyState from '../../CommonComponents/EmptyState';
import { Package } from 'lucide-react';
import { tableContainer, tableBase, tableHead, tableHeader, tableCell, tableRow } from '../../../utils/tableStyle';
import { resolveAssetUrl } from "../../../utils/assetUrl";

export default function UserTable({ users, onPreviewProfile, onEdit, onDelete, onToggleStatus, loading }) {
    return (
        <div className={tableContainer}>
            <table className={tableBase}>
                <thead className={tableHead} style={{ background: 'var(--color-primary)' }}>
                    <tr>
                        <th className={tableHeader + ' text-left'}>No.</th>
                        <th className={tableHeader + ' text-center'}>Profile</th>
                        <th className={tableHeader + ' text-left'}>Username</th>
                        <th className={tableHeader + ' text-left'}>Email</th>
                        <th className={tableHeader + ' text-left'}>Role</th>
                        <th className={tableHeader + ' text-left'}>Branch</th>
                        <th className={tableHeader + ' text-left'}>Status</th>
                        <th className={tableHeader + ' text-center'}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {loading ? (
                        <tr><td colSpan={8} className={tableCell + ' text-center py-8'}>Loading...</td></tr>
                    ) : users.length === 0 ? (
                        <tr>
                            <td colSpan={8} className={tableCell + ' text-center py-8'}>
                                <EmptyState icon={Package} message="No users found." size="default" />
                            </td>
                        </tr>
                    ) : (
                        users.map((user, idx) => (
                            <tr key={user.id} className={tableRow + ' border-b last:border-0' + (user.status === "DELETED" ? " opacity-50" : "")}>
                                <td className={tableCell + ' text-left'}>{idx + 1}</td>
                                <td className={tableCell + ' text-center'}>
                                    <button
                                        type="button"
                                        onClick={() => onPreviewProfile?.(user)}
                                        className="inline-flex h-11 w-11 items-center justify-center overflow-hidden rounded-full border border-slate-200 bg-slate-50 shadow-sm transition hover:scale-[1.03] hover:border-slate-300 hover:bg-slate-100 focus:outline-none"
                                        aria-label={`Preview ${user.username}'s profile picture`}
                                    >
                                        {resolveAssetUrl(user.profile_image) ? (
                                            <img
                                                src={resolveAssetUrl(user.profile_image)}
                                                alt={`${user.username} profile`}
                                                className="h-full w-full object-cover"
                                            />
                                        ) : (
                                            <UserCircle2 className="h-6 w-6 text-slate-400" />
                                        )}
                                    </button>
                                </td>
                                <td className={tableCell + ' text-left'}>{user.username}</td>
                                <td className={tableCell + ' text-left'}>{user.email}</td>
                                <td className={tableCell + ' text-left'}>{user.role}</td>
                                <td className={tableCell + ' text-left'}>{user.branch?.name || user.branch_name || user.branch?.location || user.branch_id || '-'}</td>
                                <td className={tableCell + ' text-left'}>
                                    <span className={`inline-block px-3 py-1 rounded-full text-xs font-medium ${user.status === "ACTIVE"
                                        ? "bg-green-100 text-green-600"
                                        : user.status === "INACTIVE"
                                            ? "bg-gray-200 text-gray-400"
                                            : "bg-red-100 text-red-600"
                                        }`}>
                                        {user.status}
                                    </span>
                                </td>
                                <td className={tableCell + ' text-center'}>
                                    <div className="flex items-center justify-center gap-3">
                                        {user.status !== "DELETED" && (
                                            <>
                                                <TableActionButtons
                                                    canEdit
                                                    canDelete
                                                    canToggle
                                                    onEdit={() => onEdit(user)}
                                                    onDelete={() => onDelete(user)}
                                                    onToggle={() => onToggleStatus(user)}
                                                    toggleStatus={user.status}
                                                />
                                            </>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}
